import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private userService: UserService, private authService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.userService.isLoggedIn()){
      let roles : Array<string>;
      if (Array.isArray(this.userService.getClaims().role)){
        roles = this.userService.getClaims().role;
      } else {
        roles = [this.userService.getClaims().role];
      }
      switch (route.url[0].path) {
        case 'audits':
          if (roles.includes('AEE_Audit') || roles.includes('AEE_Admin')){
            return true;
          }
          return this.router.parseUrl('/not-authorized');
        case 'sessions':
        case 'events':
          if (roles.includes('AEE_Admin')){
            return true;
          }
          return this.router.parseUrl('/not-authorized');
        default:
          return this.router.parseUrl('/not-authorized');
      }
    } else {
      this.authService.startAuthentication();
      return false;
    }
  }
}
